import React from 'react';
import HeadingContainer from './HeadingContainer';
import {Image} from 'semantic-ui-react';
import CONTEST_LOGO_LT from '../../resources/images/talentai-EN.SVG';
import CONTEST_LOGO_EN from '../../resources/images/talentai-LT.SVG';
import BRAND_LOGO from '../../resources/images/novameta-logo.svg';
import './Heading.css';

export default (props) => {
    return (
        <HeadingContainer lang={props.lang} selectedLanguage={props.selectedLanguage} languageValue={props.languageValue} languageOptions={props.languageOptions} days={props.days} hours={props.hours} minutes={props.minutes} seconds={props.seconds} handleChange={props.handleChange}>
            <Image style={{margin: "-1rem"}} draggable="false" floated="left" src={props.selectedLanguage !== "lithuanian"? CONTEST_LOGO_LT : CONTEST_LOGO_EN}  className="brand-logo" />
            <Image style={{cursor: "pointer"}} draggable="false" floated="right" src={BRAND_LOGO} className="brand-logo" onClick={props.selectedLanguage === "lithuanian"? () => window.location.href="http://www.novameta.lt/" : () => window.location.href="http://www.novameta.lt/en"} />
        </HeadingContainer>
    )
}


// WEBPACK FOOTER //
// ./src/components/heading/index.jsx